import { render, staticRenderFns } from "./AssignOwner.vue?vue&type=template&id=221d67cd&scoped=true"
import script from "./AssignOwner.vue?vue&type=script&lang=js"
export * from "./AssignOwner.vue?vue&type=script&lang=js"
import style0 from "./AssignOwner.vue?vue&type=style&index=0&id=221d67cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d67cd",
  null
  
)

export default component.exports